import { render, staticRenderFns } from "./load-subsidiary-file.vue?vue&type=template&id=2f49fd57&scoped=true"
import script from "./load-subsidiary-file.vue?vue&type=script&lang=js"
export * from "./load-subsidiary-file.vue?vue&type=script&lang=js"
import style0 from "./load-subsidiary-file.vue?vue&type=style&index=0&id=2f49fd57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f49fd57",
  null
  
)

export default component.exports